<template>
  <div class="documents">
    <page-header title="Документы" />
    <documents-skeleton v-if="!documents.length"/>
    <div v-else class="public-container public-container-mobile flex flex-space-between flex-align-items-start documents-container">
      <div class="documents-wrapper">
        <h2>{{ title }}</h2>
        <vz-docs-tree-item 
          v-if="!isMobile"
          :docs="documents"
          :item="documentTree[tab]"
          class="documents-tree"
        />
        <vz-switcher-accordion
          v-if="isMobile"
          v-model="tab"
          :items="tabs"
          public-style
          class="documents-switcher"
        >
          <vz-docs-tree-item 
            :docs="documents"
            :item="documentTree[tab]"
            class="documents-tree"
          />
        </vz-switcher-accordion>
      </div>
      <vz-switcher
        v-if="!isMobile"
        v-model="tab"
        :items="tabs"
        public-style
        class="documents-switcher"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { getAllDocuments } from '@/api/document'
import { IDocument, IDocumentTreeItem } from '~/types/api'
import { SwitchItem } from '~~/types/types'
import $breakpoints from '~~/composables/breakpoints'
import PageHeader from '~~/components/public/page-header.vue'
import DocumentsSkeleton from '~~/components/public/documents/documents-skeleton.vue'
import VzDocsTreeItem from '~~/components/ui-kit/vz-docs-tree-item.vue'
import VzSwitcherAccordion from '~~/components/ui-kit/vz-switcher-accordion.vue'

const documents = ref([] as IDocument[])
const documentTree = ref([] as IDocumentTreeItem[])
const tab = ref('0') // code у партнеров не везде заполнен 

const tabs = computed(() => {
  const data: SwitchItem[] = []
  documentTree.value.forEach((element, index) => {
    data.push({ title: element.name, value: index.toString(), icon: { url: '/svg/docs.svg', size: 24 } })
  });
  return data
})

const title = computed(() => {
  return tabs.value[tab.value].title
})

const isMobile = computed((): boolean => {
  return $breakpoints.isPublicXS
})

onMounted( async(): Promise<void> => {
  const { docs, tree } = await getAllDocuments()
  documents.value = docs
  documentTree.value = [tree?.[0]]
  if (tree?.[1].children) {
    documentTree.value.push(...tree[1].children)
  }
}) 
</script>